import React, { Component } from "react";
import { Row, Col, Divider, Button } from "antd";
import CoverImage from "../../components/coverImage";
import Tabs from "../../components/tab/index";
import ProfileCard from "../../components/card/index";
import PlantInformation from "../../components/EmployeCard/plantinformation";
import ConnectToStripe from "../../components/EmployeCard/ConnecttoStripe";
import BusinessDescription from "../../components/EmployeCard/businessDescription";
import AccountInfo from "../../components/EmployeCard/accountinfo";
import CreditCardInfo from "../../components/EmployeCard/creditCardinfo";
import { UserAction, AuthAction } from "../../store/actions";
import { connect } from "react-redux";
import CustomModal from "../../components/modals/customModal";
import TextInput from "../../components/input/TextInput";
import { formatToNumber } from "../../config/utils";
import { EMAIL_REGX } from "../../config/variables";
import TextField from "@mui/material/TextField";
import Delete_order from "../../assets/images/delete_order.png";
import CreditCard from "../../components/EmployeCard/creditcard";

class AccountSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        order: "asc",
        page: 1,
        per_page: 11,
        column: "email",
      },
      isPlantModal: false,
      plantPayLoad: {
        address: "",
        email: "",
        name: "",
        phone: "",
        zipcode: "",
      },
      errors: {
        addressError: "",
        emailError: "",
        phoneError: "",
        nameError: "",
        zipcodeError: "",
        store_nameError: "",
        business_nameError: "",
        employee_id_numberError: "",
        current_passwordError: "",
        new_passwordError: "",
        confirm_passwordError: "",
        first_nameError: "",
        last_nameError: "",
        descriptionError: "",
      },
      isUpdate: false,
      locationId: "",
      businessDetails: {},
      isBusinessModal: false,
      isBusinessInfoModal: false,
      businessInfo: {},
      cardDetails: {
        card_num: "",
        expire_month: "",
        expire_year: "",
        cvc: "",
      },
      isUserUpdate: false,
      userDetail: {
        address: "",
        email: "",
        first_name: "",
        last_name: "",
        phone: "",
      },
      cover: "",
      image: "",
      isChangePassword: false,
      passwordPayload: {
        current_password: "",
        new_password: "",
        confirm_password: "",
      },
      keyTab: "",
      isOpenDeleteModal: false,
      deleteLocId: "",
      isOpenCard: false,
      isOpenSubcriptionModal: false,
    };
  }
  componentDidMount() {
    const { getUserDetail, getCompanyDetails, getLocation, getCards } =
      this.props;
    const userId = JSON.parse(localStorage.getItem("trkr_Auth"))?.[2]
      ?.rmx_company_user?.id;
    getUserDetail(userId);
    getCompanyDetails();
    getLocation();
    getCards(this.state.filters);
  }
  onHandleChanged = (e) => {
    this.setState({
      plantPayLoad: {
        ...this.state.plantPayLoad,
        [e.target.name]: e.target.value,
      },
      errors: { ...this.state.errors, [`${e.target.name}Error`]: "" },
    });
  };
  onChangeBusinessDetail = (e) => {};

  onSubmit = () => {
    let nameError = "";
    let addressError = "";
    let PNError = "";
    let zpError = "";
    let EError = "";
    const {
      plantPayLoad: { address, email, name, phone, zipcode },
      isUpdate,
      locationId,
    } = this.state;
    if (
      !name.trim().length ||
      !address.trim().length ||
      !phone.trim().length ||
      !EMAIL_REGX.test(email) ||
      !zipcode.trim().length
    ) {
      if (!name.trim().length) {
        nameError = "Name is required";
        this.setState({
          errors: {
            ...this.state.errors,
            nameError,
          },
        });
      }
      if (!address.trim().length) {
        addressError = "address is required";
        this.setState({
          errors: {
            ...this.state.errors,
            nameError,
            addressError,
          },
        });
      }
      if (!phone.trim().length || phone.length < 12) {
        PNError = "Phone number is required";
        this.setState({
          errors: {
            ...this.state.errors,
            nameError,
            addressError,
            phoneError: PNError,
          },
        });
      }
      if (!EMAIL_REGX.test(email)) {
        EError = "email is required";
        this.setState({
          errors: {
            ...this.state.errors,
            nameError,
            addressError,
            phoneError: PNError,
            emailError: EError,
          },
        });
      }
      if (!zipcode?.trim().length) {
        zpError = "Zip code is required";
        this.setState({
          errors: {
            ...this.state.errors,
            nameError,
            addressError,
            phoneError: PNError,
            emailError: EError,
            zipcodeError: zpError,
          },
        });
      }
      return;
    }
    //
    !isUpdate &&
      this.props.createLocation(this.state.plantPayLoad, () =>
        this.setState({ isPlantModal: false })
      );
    isUpdate &&
      this.props.updateLocation(this.state.plantPayLoad, locationId, () =>
        this.setState({ isPlantModal: false })
      );
  };
  deleteLocationHandler = (item) => {
    this.setState({
      isOpenDeleteModal: true,
      deleteLocId: item.id,
    });
  };
  onHandleUpdate = (item) => {
    this.setState({
      plantPayLoad: {
        address: item.address,
        email: item.email,
        name: item.name,
        phone: item.phone,
        zipcode: item.zipcode,
      },
      errors: {
        nameError: "",
        emailError: "",
        phoneError: "",
        addressError: "",
        zipcodeError: "",
      },
      isUpdate: true,
      isPlantModal: true,
      locationId: item.id,
    });
  };
  businessDetailChange = (item) => {
    this.setState({
      businessDetails: item,
      isBusinessModal: true,
    });
  };
  onClickBusinessDetails = (item) => {
    this.setState({
      businessInfo: item,
      isBusinessInfoModal: true,
    });
  };
  onChangeBusinessInfo = (e) => {
    console.log("errors==>", e.target.value);
    this.setState({
      errors: { ...this.state.errors, [`${e.target.name}Error`]: "" },
      businessInfo: {
        ...this.state.businessInfo,
        [e.target.name]: e.target.value,
      },
    });
  };
  onChangeUserDetail = (e) => {
    this.setState({
      userDetail: {
        ...this.state.userDetail,
        [e.target.name]: e.target.value,
      },
      errors: {
        ...this.state.errors,
        [`${e.target.name}Error`]: "",
      },
    });
  };
  onUpdateUserInfo = (item) => {
    this.setState({
      userDetail: item,
      isUserUpdate: true,
    });
  };
  onChangePassword = (e) => {
    this.setState({
      passwordPayload: {
        ...this.state.passwordPayload,
        [e.target.name]: e.target.value,
      },
      errors: {
        ...this.state.errors,
        [`${e.target.name}Error`]: "",
      },
    });
  };
  onSubmitChangePassword = () => {
    let oldpassErr = "";
    let newPassErr = "";
    let confPassErr = "";
    const { passwordPayload } = this.state;
    if (
      !passwordPayload.current_password.trim().length ||
      !passwordPayload.new_password.trim().length ||
      passwordPayload.new_password.trim().length < 8 ||
      passwordPayload.confirm_password !== passwordPayload.new_password
    ) {
      if (!passwordPayload.current_password.trim().length) {
        oldpassErr = "Old password is required";
        this.setState({
          errors: { ...this.state.errors, current_passwordError: oldpassErr },
        });
      }
      if (!passwordPayload.new_password.trim().length) {
        newPassErr = "New password is required";
        this.setState({
          errors: {
            ...this.state.errors,
            current_passwordError: oldpassErr,
            new_passwordError: newPassErr,
          },
        });
      }
      if (passwordPayload.new_password.trim().length < 8) {
        newPassErr = "password should be at least 8 characters long.";
        this.setState({
          errors: {
            ...this.state.errors,
            current_passwordError: oldpassErr,
            new_passwordError: newPassErr,
          },
        });
      }
      if (passwordPayload.confirm_password !== passwordPayload.new_password) {
        confPassErr = "Mismatch";
        this.setState({
          errors: {
            ...this.state.errors,

            current_passwordError: oldpassErr,
            new_passwordError: newPassErr,
            confirm_passwordError: confPassErr,
          },
        });
      }
      return;
    }
    this.props.changePassword(this.state.passwordPayload, () =>
      this.setState({
        isChangePassword: false,
      })
    );
  };
  onHandleUserInfo = () => {
    const { userDetail } = this.state;
    let first_nameError = "";
    let last_nameError = "";
    let emailError = "";
    let phoneError = "";

    if (
      !userDetail?.first_name.trim().length ||
      !userDetail?.last_name.trim().length ||
      !EMAIL_REGX.test(userDetail.email) ||
      !userDetail?.phone.trim().length ||
      (userDetail?.phone.trim().length && userDetail.phone.length < 12)
    ) {
      if (!userDetail?.first_name.trim().length) {
        first_nameError = "First name is required.";
        this.setState({
          ...this.state,
          errors: {
            ...this.state.errors,
            first_nameError,
          },
        });
      }
      if (!userDetail?.last_name.trim().length) {
        last_nameError = "Last name is required.";
        this.setState({
          ...this.state,
          errors: {
            ...this.state.errors,
            first_nameError,
            last_nameError,
          },
        });
      }
      if (!EMAIL_REGX.test(userDetail?.email)) {
        emailError = "Email is required.";

        this.setState({
          errors: {
            ...this.state.errors,
            first_nameError,
            last_nameError,
            emailError,
          },
        });
      }
      if (!userDetail?.phone.trim().length || userDetail.phone.length < 12) {
        phoneError = "Phone is required.";

        this.setState({
          errors: {
            ...this.state.errors,
            first_nameError,
            last_nameError,
            emailError,
            phoneError,
          },
        });
      }
      return;
    }
    this.props.updateProfileInfo(this.state.userDetail, () =>
      this.setState({
        isUserUpdate: false,
      })
    );
  };
  updateStoreInfo = () => {
    let store_nameError = "";
    let descriptionError = "";
    if (
      !this.state.businessDetails?.rmx_company_asset?.store_name?.trim()?.length
    ) {
      if (
        !this.state.businessDetails?.rmx_company_asset?.store_name?.trim()
          ?.length
      ) {
        store_nameError = "Store name is required.";
        this.setState({
          errors: {
            ...this.state.errors,
            store_nameError,
          },
        });
      }
      return;
    }
    this.props.updateAssets(
      this.state?.businessDetails?.rmx_company_asset?.id,
      this.state?.businessDetails,
      () =>
        this.setState({
          isBusinessModal: false,
        })
    );
  };
  updateBusinessInfo = () => {
    const { businessInfo } = this.state;
    if (
      !businessInfo.business_name.trim().length ||
      !EMAIL_REGX.test(businessInfo.email) ||
      !businessInfo.phone.trim().length ||
      businessInfo.phone.trim().length < 12 ||
      !businessInfo.address.trim().length ||
      !businessInfo.employee_id_number.trim().length
    ) {
      let business_nameError = "";
      let emailError = "";
      let phoneError = "";
      let addressError = "";
      let employee_id_numberError = "";
      if (!businessInfo.business_name.trim().length) {
        business_nameError = "Business name is required.";
        this.setState({
          errors: {
            ...this.state.errors,
            business_nameError,
          },
        });
      }
      if (!EMAIL_REGX.test(businessInfo.email)) {
        emailError = "Email is required.";
        this.setState({
          errors: {
            ...this.state.errors,
            emailError,
            business_nameError,
          },
        });
      }
      if (!businessInfo.phone.trim().length) {
        phoneError = "Phone is required.";

        this.setState({
          errors: {
            ...this.state.errors,
            phoneError,
            emailError,
            business_nameError,
          },
        });
      }
      if (businessInfo.phone.trim().length < 12) {
        phoneError = "Phone is required.";
        this.setState({
          errors: {
            ...this.state.errors,
            phoneError,
            emailError,
            business_nameError,
          },
        });
      }
      if (!businessInfo.address.trim().length) {
        addressError = "Address is required.";
        this.setState({
          errors: {
            ...this.state.errors,
            addressError,
            phoneError,
            emailError,
            business_nameError,
          },
        });
      }
      if (!businessInfo.employee_id_number.trim().length) {
        employee_id_numberError = "Employer identification number is required.";
        this.setState({
          errors: {
            ...this.state.errors,
            employee_id_numberError,
            addressError,
            phoneError,
            emailError,
            business_nameError,
          },
        });
      }
      return;
    }
    this.props.updateBusinessInfo(this.state.businessInfo, () =>
      this.setState({
        isBusinessInfoModal: false,
      })
    );
  };
  cardHandleChanged = (e) => {
    this.setState({
      cardDetails: {
        ...this.state.cardDetails,
        [e.target.name]: e.target.value,
      },
    });
  };
  render() {
    const {
      plantPayLoad: { address, email, name, phone, zipcode },
      isPlantModal,
      errors: {
        addressError,
        emailError,
        phoneError,
        nameError,
        zipcodeError,
        store_nameError,
        current_passwordError,
        new_passwordError,
        confirm_passwordError,
        first_nameError,
        last_nameError,
        employee_id_numberError,
        business_nameError,
      },
      isBusinessInfoModal,
      businessInfo,
      cardDetails,
      isUserUpdate,
      userDetail,
      isChangePassword,
      passwordPayload,
      keyTab,
    } = this.state;
    const { companyDetails, updateAssets, updateProfileInfo } = this.props;

    return (
      <Row
        justify="space-around"
        style={{ background: "white", marginTop: "20px" }}
      >
        <Col span={24}>
          <CoverImage
            keyTab={this.state.keyTab}
            userImage={
              keyTab == "2" ? this.props.companyDetails : this.props?.userDetail
            }
            CoverImage={
              this?.props?.companyDetails?.rmx_company_asset?.cover?.original
            }
            onChangeCoverImage={(e) =>
              updateAssets(companyDetails?.rmx_company_asset?.id, {
                cover: e.target.files[0],
              })
            }
            onChangeBusinessImage={(e) => {
              updateAssets(companyDetails?.rmx_company_asset?.id, {
                logo: e.target.files[0],
              });
            }}
            onChangeProfileImage={(e) => {
              updateProfileInfo({ image: e.target.files[0] });
            }}
          />
        </Col>
        <Col
          xl={16}
          sm={24}
          xs={24}
          md={24}
          lg={24}
          // span={16}
          style={{ marginLeft: 20 }}
        >
          <Tabs
            onChangeTab={(e) =>
              this.setState({
                keyTab: e,
              })
            }
            plantData={[
              {
                key: "Profile",
                component: () => (
                  <>
                    <ProfileCard
                      headingText={`Profile Information`}
                      userDetail={this.props.userDetail}
                      onUpdateUserInfo={this.onUpdateUserInfo}
                      openChangePassword={() =>
                        this.setState({
                          isChangePassword: true,
                          errors: {
                            ...this.state.errors,
                            current_passwordError: "",
                            new_passwordError: "",
                            confirm_passwordError: "",
                          },
                          passwordPayload: {
                            current_password: "",
                            new_password: "",
                            confirm_password: "",
                          },
                        })
                      }
                    />
                  </>
                ),
              },
              {
                key: "Business",
                component: () => (
                  <>
                    <BusinessDescription
                      companyDetails={this.props.companyDetails}
                      businessDetailChange={this.businessDetailChange}
                    />
                    <ConnectToStripe
                      companyDetails={this.props.companyDetails}
                    />
                    <ProfileCard
                      businessInfo={true}
                      headingText={`Business Information `}
                      userDetail={this.props.companyDetails}
                      onClickBusinessDetails={this.onClickBusinessDetails}
                    />
                    <PlantInformation
                      onChangePlantModal={() =>
                        this.setState({
                          isPlantModal: true,
                          plantPayLoad: {
                            address: "",
                            email: "",
                            name: "",
                            phone: "",
                            zipcode: "",
                          },
                          errors: {
                            ...this.state.errors,
                            addressError: "",
                            emailError: "",
                            nameError: "",
                            phoneError: "",
                            zipcodeError: "",
                          },

                          isUpdate: false,
                        })
                      }
                      locations={this.props.locations}
                      deleteHandler={this.deleteLocationHandler}
                      onHandleUpdate={this.onHandleUpdate}
                    />
                  </>
                ),
              },
              {
                key: "Account",
                component: () => (
                  <>
                    <AccountInfo
                      companyDetails={this.props.companyDetails}
                      isOpenSubcriptionModal={() =>
                        this.setState({
                          isOpenSubcriptionModal: true,
                        })
                      }
                    />
                    <CreditCardInfo
                      cards={this.props.cards}
                      isOpenCard={() => this.setState({ isOpenCard: true })}
                    />
                  </>
                ),
              },
            ]}
          />
        </Col>

        <CustomModal
          visible={this.state.isBusinessModal}
          onCancelModal={() =>
            this.setState({
              isBusinessModal: false,
            })
          }
          footer={[
            <Button
              style={{
                backgroundColor: "#ff9800",
                color: "#fff",
                width: "30%",
                border: "none",
              }}
              onClick={this.updateStoreInfo}
            >
              Save
            </Button>,
          ]}
        >
          <Col xl={24}>
            <h5 className="text-center st-primary">Edit Store Information</h5>
            <Divider />
          </Col>
          <Col xl={24} className="pointer-cursor">
            <Row justify="center">
              <Col xl={24}>
                <form>
                  <Row justify="space-between" gutter={[5, 30]}>
                    <Col xl={24}>
                      <TextInput
                        label="Store Name"
                        name="store_name"
                        onChange={(e) => {
                          this.setState({
                            businessDetails: {
                              ...this.state.businessDetails,
                              rmx_company_asset: {
                                ...this.state.businessDetails.rmx_company_asset,
                                store_name: e.target.value,
                              },
                            },
                            errors: {
                              ...this.state.errors,
                              store_nameError: "",
                            },
                          });
                        }}
                        value={
                          this.state?.businessDetails?.rmx_company_asset
                            ?.store_name
                        }
                        required
                      />
                      <span className="danger-color text-right">
                        {store_nameError && store_nameError}
                      </span>
                    </Col>
                    <Col xl={24}>
                      <TextField
                        id="standard-multiline-static"
                        label="Description"
                        multiline
                        rows={4}
                        variant="standard"
                        name="description"
                        required
                        InputLabelProps={{
                          style: { color: "#26a69a" },
                        }}
                        sx={{
                          "& .MuiFormLabel-asterisk.MuiInputLabel-asterisk": {
                            color: "orange",
                          },
                        }}
                        onChange={(e) => {
                          this.setState({
                            businessDetails: {
                              ...this.state.businessDetails,
                              rmx_company_asset: {
                                ...this.state.businessDetails.rmx_company_asset,
                                description: e.target.value,
                              },
                            },
                            errors: {
                              ...this.state.errors,
                              descriptionError: "",
                            },
                          });
                        }}
                        value={
                          this.state?.businessDetails?.rmx_company_asset
                            ?.description
                        }
                        fullWidth={true}
                      />
                      <span className="danger-color text-right">
                        {this.state.errors?.descriptionError &&
                          this.state.errors?.descriptionError}
                      </span>
                      {/* <TextInput
                        label="Description"
                        name="description"
                        onChange={(e) => {
                          this.setState({
                            businessDetails: {
                              ...this.state.businessDetails,
                              rmx_company_asset: {
                                ...this.state.businessDetails.rmx_company_asset,
                                description: e.target.value,
                              },
                            },
                          });
                        }}
                        value={
                          this.state?.businessDetails?.rmx_company_asset
                            ?.description
                        }
                        required
                      /> */}
                    </Col>
                  </Row>
                </form>
              </Col>
            </Row>
          </Col>
        </CustomModal>
        <CustomModal
          visible={isPlantModal}
          onCancelModal={() =>
            this.setState({
              isPlantModal: false,
            })
          }
          footer={[
            <Button
              style={{
                backgroundColor: "#ff9800",
                color: "#fff",
                width: "30%",
                border: "none",
              }}
              onClick={this.onSubmit}
            >
              Save
            </Button>,
          ]}
        >
          <Col xl={24}>
            <h5 className="text-center st-primary">Add Plant</h5>
            <Divider />
          </Col>
          <Col xl={24} className="pointer-cursor">
            <Row justify="center">
              <Col xl={24}>
                <form>
                  <Row justify="space-between" gutter={[5, 30]}>
                    <Col xl={24}>
                      <TextInput
                        label="Name"
                        name="name"
                        onChange={this.onHandleChanged}
                        value={name}
                        required
                      />
                      <span className="danger-color">
                        {nameError && nameError}
                      </span>
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="Email"
                        name="email"
                        onChange={this.onHandleChanged}
                        value={email}
                        required
                      />
                      <span className="danger-color">
                        {emailError && emailError}
                      </span>
                    </Col>{" "}
                    <Col xl={24}>
                      <TextInput
                        label="phone"
                        name="phone"
                        onChange={this.onHandleChanged}
                        value={formatToNumber(phone)}
                        required
                      />
                      <span className="danger-color">
                        {phoneError && phoneError}
                      </span>
                    </Col>{" "}
                    <Col xl={24}>
                      <TextInput
                        label="Address"
                        name="address"
                        onChange={this.onHandleChanged}
                        value={address}
                        required
                      />
                      <span className="danger-color">
                        {addressError && addressError}
                      </span>
                    </Col>{" "}
                    <Col xl={24}>
                      <TextInput
                        label="Zip Code"
                        name="zipcode"
                        onChange={this.onHandleChanged}
                        value={zipcode}
                        required
                      />
                      <span className="danger-color">
                        {zipcodeError && zipcodeError}
                      </span>
                    </Col>
                  </Row>
                </form>{" "}
              </Col>
            </Row>
          </Col>
        </CustomModal>

        <CustomModal
          visible={isBusinessInfoModal}
          onCancelModal={() =>
            this.setState({
              isBusinessInfoModal: false,
            })
          }
          footer={[
            <Button
              style={{
                backgroundColor: "#ff9800",
                color: "#fff",
                width: "30%",
                border: "none",
              }}
              onClick={this.updateBusinessInfo}
            >
              Save
            </Button>,
          ]}
        >
          <Col xl={24}>
            <h5 className="text-center st-primary">Edit Information</h5>
            <Divider />
          </Col>
          <Col xl={24} className="pointer-cursor">
            <Row justify="center">
              <Col xl={24}>
                <form>
                  <Row justify="space-between" gutter={[5, 30]}>
                    <Col xl={24}>
                      <TextInput
                        label="Business Name"
                        name="business_name"
                        onChange={this.onChangeBusinessInfo}
                        value={businessInfo.business_name}
                        required
                      />
                      <span className="danger-color">
                        {business_nameError && business_nameError}
                      </span>
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="Email"
                        name="email"
                        onChange={this.onChangeBusinessInfo}
                        value={businessInfo.email}
                        required
                      />
                      <span className="danger-color">
                        {emailError && emailError}
                      </span>
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="Phone"
                        name="phone"
                        onChange={this.onChangeBusinessInfo}
                        value={formatToNumber(businessInfo.phone || "")}
                        required
                      />
                      <span className="danger-color">
                        {phoneError && phoneError}
                      </span>
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="Address"
                        name="address"
                        onChange={this.onChangeBusinessInfo}
                        value={businessInfo.address}
                        required
                      />
                      <span className="danger-color">
                        {addressError && addressError}
                      </span>
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="Employer Identification Number "
                        name="employee_id_number"
                        onChange={this.onChangeBusinessInfo}
                        value={businessInfo.employee_id_number}
                        required
                      />
                      <span className="danger-color">
                        {employee_id_numberError && employee_id_numberError}
                      </span>
                    </Col>
                  </Row>
                </form>
              </Col>
            </Row>
          </Col>
        </CustomModal>

        <CustomModal
          visible={isUserUpdate}
          onCancelModal={() =>
            this.setState({
              isUserUpdate: false,
            })
          }
          footer={[
            <Button
              style={{
                backgroundColor: "#ff9800",
                color: "#fff",
                width: "30%",
                border: "none",
              }}
              onClick={() => {
                this.onHandleUserInfo();
              }}
            >
              Save
            </Button>,
          ]}
        >
          <Col xl={24}>
            <h5 className="text-center st-primary">Edit User Info</h5>
            <Divider />
          </Col>
          <Col xl={24} className="pointer-cursor">
            <Row justify="center">
              <Col xl={24}>
                <form>
                  <Row justify="space-between" gutter={[5, 30]}>
                    <Col xl={24}>
                      <TextInput
                        label="First Name"
                        name="first_name"
                        onChange={this.onChangeUserDetail}
                        value={userDetail.first_name}
                        required
                      />
                      <span className="danger-color text-right">
                        {first_nameError && first_nameError}
                      </span>
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="Last Name"
                        name="last_name"
                        onChange={this.onChangeUserDetail}
                        value={userDetail.last_name}
                        required
                      />
                      <span className="danger-color text-right">
                        {last_nameError && last_nameError}
                      </span>
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="Email"
                        name="email"
                        onChange={this.onChangeUserDetail}
                        value={userDetail.email}
                        required
                      />
                      <span className="danger-color text-right">
                        {emailError && emailError}
                      </span>
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="Phone"
                        name="phone"
                        onChange={this.onChangeUserDetail}
                        value={formatToNumber(userDetail.phone || "")}
                        required
                      />
                      <span className="danger-color">
                        {phoneError && phoneError}
                      </span>
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="Address"
                        name="address"
                        onChange={this.onChangeUserDetail}
                        value={userDetail.address}
                      />
                      {/* <span className="danger-color">
                        {nameError && nameError}
                      </span> */}
                    </Col>
                  </Row>
                </form>
              </Col>
            </Row>
          </Col>
        </CustomModal>

        <CustomModal
          visible={isChangePassword}
          onCancelModal={() =>
            this.setState({
              isChangePassword: false,
            })
          }
          footer={[
            <Button
              style={{
                backgroundColor: "#ff9800",
                color: "#fff",
                width: "30%",
                border: "none",
              }}
              onClick={() => this.onSubmitChangePassword()}
            >
              Save
            </Button>,
          ]}
        >
          <Col xl={24}>
            <h5 className="text-center st-primary">Edit/Change Password</h5>
            <Divider />
          </Col>
          <Col xl={24} className="pointer-cursor">
            <Row justify="center">
              <Col xl={24}>
                <form>
                  <Row justify="space-between" gutter={[5, 30]}>
                    <Col xl={24}>
                      <TextInput
                        label="Current Password"
                        name="current_password"
                        onChange={this.onChangePassword}
                        value={passwordPayload.current_password}
                        required
                        type="password"
                      />
                      <span className="danger-color">
                        {current_passwordError && current_passwordError}
                      </span>
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="New Password"
                        name="new_password"
                        onChange={this.onChangePassword}
                        value={passwordPayload.new_password}
                        required
                        type="password"
                      />
                      <span className="danger-color">
                        {new_passwordError && new_passwordError}
                      </span>
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="Confirm Password"
                        name="confirm_password"
                        onChange={this.onChangePassword}
                        value={passwordPayload.confirm_password}
                        required
                        type="password"
                      />
                      <span className="danger-color">
                        {confirm_passwordError && confirm_passwordError}
                      </span>
                    </Col>
                  </Row>
                </form>
              </Col>
            </Row>
          </Col>
        </CustomModal>
        <CustomModal
          visible={this.state.isOpenDeleteModal}
          onCancelModal={() =>
            this.setState({
              isOpenDeleteModal: false,
            })
          }
          footer={[
            <Row justify="center" style={{ margin: "20px" }}>
              <Col
                className="d-flex justify-content-center"
                style={{ width: "100%" }}
              >
                <Button
                  style={{
                    backgroundColor: "#ff9800",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() =>
                    this.props.deleteLocation(this.state.deleteLocId, () => {
                      this.setState({
                        isOpenDeleteModal: false,
                        deleteLocId: "",
                      });
                    })
                  }
                >
                  YES
                </Button>
                <Button
                  style={{
                    backgroundColor: "#26a69a ",
                    color: "#fff",
                    width: "30%",
                    border: "none",
                  }}
                  onClick={() =>
                    this.setState({
                      isOpenDeleteModal: false,
                    })
                  }
                >
                  NO
                </Button>
              </Col>
            </Row>,
          ]}
        >
          <Row justify="center">
            <Col className="d-flex justify-content-center" span={24}>
              <img src={Delete_order} />
            </Col>
            <Col span={24} style={{ textAlign: "center" }}>
              <span>Are you sure you want to delete this plant ?</span>
            </Col>
          </Row>
        </CustomModal>

        <CustomModal
          visible={this.state.isOpenCard}
          onCancelModal={() =>
            this.setState({
              isOpenCard: false,
            })
          }
          footer={[
            <Button
              style={{
                backgroundColor: "#ff9800",
                color: "#fff",
                width: "30%",
                border: "none",
              }}
              // onClick={() => this.onSubmitChangePassword()}
            >
              Save
            </Button>,
          ]}
        >
          <Col xl={24}>
            <h5 className="text-center st-primary">Add Card</h5>
            <Divider />
          </Col>
          <Col xl={24} className="pointer-cursor">
            <Row>
              <Col xl={24}>
                <form>
                  <Row justify="space-between" gutter={[5, 20]}>
                    <Col xl={24}>
                      <TextInput
                        label="Card Number "
                        name="card_num"
                        required
                        value={cardDetails.card_num}
                        onChange={this.cardHandleChanged}
                      />
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="Expiry Month"
                        name="expire_month"
                        required
                        value={cardDetails.expire_month}
                        onChange={this.cardHandleChanged}
                      />
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="Expiry Year"
                        name="expire_year"
                        required
                        value={cardDetails.expire_year}
                        onChange={this.cardHandleChanged}
                      />
                    </Col>
                    <Col xl={24}>
                      <TextInput
                        label="CVC"
                        name="cvc"
                        required
                        value={cardDetails.cvc}
                        onChange={this.cardHandleChanged}
                      />
                    </Col>
                  </Row>
                </form>
              </Col>
            </Row>
          </Col>
        </CustomModal>
        <CustomModal
          visible={this.state.isOpenSubcriptionModal}
          onCancelModal={() =>
            this.setState({
              isOpenSubcriptionModal: false,
            })
          }
          footer={[
            <Button
              style={{
                backgroundColor: "#F6695E",
                color: "white",
                width: "30%",
                border: "none",
              }}
              // onClick={() => this.onSubmitChangePassword()}
            >
              UNSUBSCRIBE
            </Button>,
            <Button
              style={{
                backgroundColor: "lightgrey",
                color: "black",
                width: "30%",
                border: "none",
              }}
              onClick={() =>
                this.setState({
                  isOpenSubcriptionModal: false,
                })
              }
            >
              CLOSE
            </Button>,
          ]}
        >
          <Col xl={24}>
            <h5 className="text-center st-primary">Manage Subscription</h5>
          </Col>
          <Col xl={24} className="pointer-cursor">
            <Row justify="center">
              <Col xl={12}>
                <p>
                  Your subscription is valid till February 07, 2022 & you have
                  currently been making payment using the card as depicted on
                  the right.
                </p>
              </Col>
              <Col xl={12}>
                <CreditCard
                  cardStyle={{
                    color: "black",
                    fontSize: "15px",
                  }}
                  shipVisaStyling={true}
                  paidText={false}
                  cards={[]}
                  fromOrder={true}
                  // data={OrderDetail?.order_stripe_charge?.charge}
                />
              </Col>
            </Row>
          </Col>
        </CustomModal>
      </Row>
    );
  }
}
const mapStateToProps = (store) => {
  return {
    userDetail: store.UserReducer.userDetails,
    companyDetails: store.UserReducer.companyDetails,
    locations: store.UserReducer.locations,
    cards: store.UserReducer.cards,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getUserDetail: (userId) => dispatch(UserAction.getUserDetailReq(userId)),
    getCompanyDetails: () => dispatch(UserAction.getCompantDetailReq()),
    getLocation: () => dispatch(UserAction.getLocationReq()),
    getCards: (params) => dispatch(UserAction.getCardsReq(params)),
    createLocation: (payload, cb) =>
      dispatch(UserAction.createLocationReq(payload, cb)),
    deleteLocation: (id, cb) => dispatch(UserAction.deleteLocationReq(id, cb)),
    updateLocation: (id, body, cb) =>
      dispatch(UserAction.UpdateLocationReq(id, body, cb)),
    updateAssets: (id, body, cb) =>
      dispatch(UserAction.updateAssetsReq(id, body, cb)),
    updateBusinessInfo: (body, cb) =>
      dispatch(UserAction.updateBusinessInfoReq(body, cb)),
    updateProfileInfo: (body, cb) =>
      dispatch(UserAction.updateProfileInfoReq(body, cb)),
    changePassword: (body, cb) => dispatch(AuthAction.ResetPassword(body, cb)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AccountSetting);
